import SUApi from './_suApi';

class SUIncrementDecrementAPI extends SUApi {
  constructor() {
    super();
  }
  controllerName = 'SuIncrementDecrements';
}

export default new SUIncrementDecrementAPI();
